import { defineMessages } from 'react-intl';

import { addAndRemoveObjectsFromArray } from '../../../helpers';

import Default from './Default';
import Specific from './Specific';
import WithImages from './WithImages';

defineMessages({
  defaultVariation: {
    id: 'Default',
    defaultMessage: 'Default',
  },
  withImagesVariation: {
    id: 'With images',
    defaultMessage: 'With images',
  },
  specificVariation: {
    id: 'Specific',
    defaultMessage: 'Specific',
  },
});

const removedDefaultVariations = ['default', 'summary', 'imageGallery'];

export const specificVariationId = 'specific';

const listingVariations = [
  {
    id: 'default',
    isDefault: true,
    title: 'Default',
    template: Default,
  },
  {
    id: 'withImages',
    isDefault: false,
    title: 'With images',
    template: WithImages,
  },
  {
    id: specificVariationId,
    isDefault: false,
    title: 'Specific',
    template: Specific,
  },
];

const applyConfig = (config) => {
  config.blocks.blocksConfig.listing.variations = addAndRemoveObjectsFromArray(
    config.blocks.blocksConfig.listing.variations,
    listingVariations,
    removedDefaultVariations,
  );

  return config;
};

export default applyConfig;
